import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import MuiPagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import padStart from 'lodash/padStart'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import FormSelect from '../FormCreator/FormItem/FormSelect'

const Pagination = ({
  onPageChange,
  pageCount = 0,
  page: propsPage = 0,
  pageSize = 10,
  onPageSizeChange,
  sideComponent,
}) => {
  const { t } = useTranslation()
  const [rowsPerPage, setRowsPerPage] = useState(pageSize)
  const [page, setPage] = useState(propsPage)

  const handlePageChange = p => {
    onPageChange?.(p)
    setPage(p)
  }

  useEffect(() => {
    setPage(propsPage)
  }, [propsPage])

  useEffect(() => {
    setRowsPerPage(pageSize)
  }, [pageSize])

  return (
    <Grid container alignItems="center" justifyContent="flex-end" spacing={2} sx={{ ml: 0 }}>
      <Grid item>
        <IconButton
          disabled={page <= 0}
          size="small"
          onClick={() => {
            handlePageChange(Math.max(page - 1, 0))
          }}
          color="secondary_80"
          sx={{ fontSize: 14 }}
        >
          {'<'}
        </IconButton>
      </Grid>

      <Grid item>
        <MuiPagination
          count={pageCount}
          page={page + 1}
          onChange={(_, newPage) => {
            handlePageChange(newPage - 1)
          }}
          renderItem={item => {
            const { page: itemPage } = item

            return (
              <Box sx={{ mx: 0.5, position: 'relative' }}>
                {itemPage && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      fontSize: 12,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        color: theme =>
                          page + 1 === itemPage
                            ? theme.palette.primary.main
                            : theme.palette.secondary_80.main,
                      }}
                    >
                      {padStart(itemPage, 2, '0')}
                    </Box>
                  </Box>
                )}
                <PaginationItem sx={{ opacity: 0 }} {...item} />
              </Box>
            )
          }}
          hideNextButton
          hidePrevButton
          variant="outlined"
          shape="rounded"
          sx={{
            '& .MuiPagination-ul': {
              '& .MuiPaginationItem-page': {
                mx: '-.5px',
                borderRadius: 0,
                border: 'none',
                backgroundColor: theme => theme.palette.other.white.main,
                color: theme => theme.palette.secondary[80].main,
                fontSize: 12,

                '&.Mui-selected': { color: theme => theme.palette.primary.main },
              },
            },
          }}
          size="small"
          color="primary"
        />
      </Grid>

      <Grid item>
        <IconButton
          disabled={page >= pageCount - 1}
          size="small"
          onClick={() => {
            handlePageChange(Math.max(page + 1, 0))
          }}
          color="secondary_80"
          sx={{ fontSize: 14 }}
        >
          {'>'}
        </IconButton>
      </Grid>

      <Grid item>
        <FormSelect
          inputConfig={{
            options: [
              { value: 10, label: '10' },
              { value: 25, label: '25' },
              { value: 50, label: '50' },
              { value: 100, label: '100' },
            ],
            inputBaseProps: {
              sx: {
                '& .MuiTypography-root': { fontSize: 12 },
                alignItems: 'center',
              },
              labelSuffix: '',
              item: true,
            },
            value: rowsPerPage,
            name: 'pagination',
            onChange: e => {
              setRowsPerPage(e.target.value)
              onPageChange(0)
              onPageSizeChange?.(e.target.value)
            },
            sx: {
              mt: '.5px',
              '& .MuiInputBase-root': {
                height: 26,
                width: 80,
                fontSize: 12,
                borderRadius: '3px',
                backgroundColor: '#2D2D6C33',
                color: theme => theme.palette.secondary_80.main,
              },
              '& .MuiSelect-select': { paddingRight: '0 !important' },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            },
          }}
          itemProps={{
            label: t('table.rows_per_page'),
            SelectProps: {
              sx: {
                '& .MuiSelect-icon': {
                  color: theme => theme.palette.secondary_80.main,
                },
              },
              IconComponent: props => (
                <Box
                  {...props}
                  sx={{
                    userSelect: 'none',
                    width: '1em',
                    height: '1em',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    fontSize: '1.3em',
                  }}
                >
                  <Box sx={{ transform: 'scaleY(.4)' }}>{'V'}</Box>
                </Box>
                // <KeyboardArrowDown {...props} />
              ),
              MenuProps: {
                sx: {
                  '& .MuiMenuItem-root': {
                    fontSize: 12,
                  },
                },
              },
            },
          }}
        />
      </Grid>
      {/* <Grid item flex={1} /> */}
      {sideComponent && <Grid item>{sideComponent}</Grid>}
    </Grid>
  )
}

export default Pagination
